import React from 'react';
import { Grid, MenuItem, Divider, Button, Box } from '@mui/material';
import { styles } from './styles';
import { Plus } from '../../../assets/icons/plus';
import { Remove } from '../../../assets/icons/remove';
import TextField from '../../../components/common/InputField/TextField';

const MAX_DEPARTMENTS = 10;

const getFieldError = (serverFieldErrors, touched, errors, index, field) =>
    serverFieldErrors?.[index]?.[field] || (touched?.[index]?.[field] && errors?.[index]?.[field]) || '';

const DepartmentFields = (props) => {
    const {
        departments,
        setDepartments,
        statusOptions,
        errors,
        touched,
        serverFieldErrors = [],
        onBlur,
        onClearServerError,
    } = props;

    const handleAdd = () => {
        if (departments.length >= MAX_DEPARTMENTS) return;
        setDepartments([
            ...departments,
            {
                name: '',
                status: 'Active',
            },
        ]);
    };

    const handleChange = (index, value, type) => {
        if (type === 'name') onClearServerError?.(index);
        const updated = [...departments];
        updated[index] = { ...updated[index], [type]: value };
        setDepartments(updated);
    };

    const handleRemove = (index) => {
        const updated = [...departments];
        updated.splice(index, 1);
        setDepartments(updated);
    };

    return (
        <>
            <Grid
                item
                sx={{
                    display: 'flex',
                    justifyContent: 'right',
                    alignItems: 'center',
                    width: '100%',
                    pt: '0px !important',
                }}
            >
                <Button
                    color="primary"
                    disabled={departments.length >= MAX_DEPARTMENTS}
                    onClick={handleAdd}
                    size="large"
                    variant="text"
                    startIcon={<Plus />}
                >
                    Add Department
                </Button>
            </Grid>
            <Grid item xs={12} sx={{ pt: '0px !important' }}>
                {departments.map((item, index) => {
                    const nameError = getFieldError(serverFieldErrors, touched, errors, index, 'name');
                    const statusError = getFieldError(serverFieldErrors, touched, errors, index, 'status');

                    return (
                    <Grid container spacing={6} pt="24px" key={index}>
                        <Grid item xs={4}>
                            <TextField
                                error={Boolean(nameError)}
                                fullWidth
                                helperText={nameError}
                                label="Name"
                                name={`departments[${index}].name`}
                                onBlur={() => onBlur?.(`departments[${index}].name`)}
                                onChange={(event) => handleChange(index, event.target.value, 'name')}
                                value={item.name}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                error={Boolean(statusError)}
                                label="Status"
                                name={`departments[${index}].status`}
                                helperText={statusError}
                                onBlur={() => onBlur?.(`departments[${index}].status`)}
                                onChange={(event) => handleChange(index, event.target.value, 'status')}
                                select
                                value={item.status}
                            >
                                {statusOptions.map((status) => (
                                    <MenuItem key={status} value={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {departments.length > 1 && (
                            <Grid item xs={4}>
                                <Box sx={styles.removeButtonBox}>
                                    <Button
                                        onClick={() => handleRemove(index)}
                                        size="large"
                                        sx={styles.removeButton}
                                        variant="text"
                                        startIcon={<Remove />}
                                    >
                                        Remove
                                    </Button>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                    );
                })}
            </Grid>
            <Grid item sx={styles.dividerWrapper}>
                <Divider flexItem orientation="horizontal" sx={styles.divider} />
            </Grid>
        </>
    );
};

export default React.memo(DepartmentFields);
